export default "__VITE_ASSET__DRIqdS7b__"